import React from "react"
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import styled  from "styled-components"
import {Tokens, ButtonLink, ExternalButton, DisabledButton, Video, Browser} from "../components/DesignSystem"

const ProjectWrapper = styled.article`
    position: sticky;
    width: 100%;
    top: 0;
    transition: all 0.1s;
    color: var(--darkBlue);
    .project {
        transition: transform 0.1s;
        border-radius: 1.5rem;
        margin-bottom: 1rem;
        box-shadow: 0 -1px 4rem rgba(0,0,0,0.01), 0 0 2rem rgba(0, 0, 0, 0.06);
        border-top: 1px solid rgba(255,255,255,0.3);
        width: 100%;
        /* height: 36rem; */
        background: var(--lightGray) !important;
        display: flex;
        align-items: center;
        transform-origin: center top;
        padding: 2rem 0;
        .info {
            width: 50%;
            padding: 0 4rem;
            transition: opacity 0.3s, transform 0.3s;
        }
        .cover {
            transition: opacity 0.3s, transform 0.3s;
            padding: 0 4rem 0 0;
            display: flex;
            line-height: 0;
            justify-content: space-between;
      
            &.mobile {
                width: 50%;
                > div {
                    width: calc(50% - 1rem);
                }
            }
            &.web {
                width: 100%;
                padding-left: 3rem;
            }
            video {
                outline: none;
                margin-bottom: -1px;
                margin-right: -1px;
            }
           
        }
    }
    h2 {
        font-size: 2rem;
        margin-top: 1.75rem;
        line-height: 1.2;
        max-width: 320px;
    }
    h3 {
        font-size: 1.25rem;
        margin-top: 0.75rem;
        font-weight: var(--normal);
    }

    ${ButtonLink}, ${ExternalButton}, ${DisabledButton} {
        margin-top: 2rem;
    }
    @media ${Tokens.md} {
        position: static;
        .project {
            display: block;
            height: auto;
            min-height: 40rem;
            padding: 2rem 0;
            .info {
                width: 100%;
                padding: 0 2rem;
            }
            .cover {
                padding: 0 2rem;
                margin-top: 2.5rem;
                &.mobile {
                    width: 100%;
                    > div {
                        width: calc(50% - 0.5rem);
                    }
                }
                &.web {
                    padding-left: 2rem;
                }
            }
        }
        h2 {
            max-width: 100%;
            font-size: 1.75rem;
            margin-top: 1rem;
        }
        h3 {
            font-size: 1rem;
        }
        ${ButtonLink}, ${ExternalButton} {
            margin-top: 1.25rem;
        }
    }
    
`



const Project = (props) => {

    const lastTop = (props.i+1) * 20;
 
    const projectType = (props.cover2) ? 'mobile' : 'web';


     return (
         <ProjectWrapper style={{transform: `translateY(${lastTop}px)`}} >
     
             <main className="project" style={{ background: (props.background) ? props.background : '#FFFFFF'}}>
             <div className="info">
             <img src={props.logo.publicURL} alt={props.title} />
             <h2>{props.tagline}</h2>

             <h3>{props.title} - {props.date}</h3>
             { (props.type === 'link') && <ExternalButton href={props.link} target="__blank">View website ↗</ExternalButton> }
             { (props.type === 'casestudy') && <ButtonLink to={props.slug} state={{fromHome: true}}>View case study →</ButtonLink> }
             { (props.type === 'private') && <DisabledButton type="button" disabled>Private project</DisabledButton> }
            
             </div>
             <div className={`cover ${projectType}`}>
                 
                 {(props.cover && props.cover2) && <><GatsbyImage image={getImage(props.cover.childImageSharp)} alt={props.title} /><GatsbyImage image={getImage(props.cover2.childImageSharp)} alt={props.title} /></>}
             
                 {props.web && <Browser address>
                     {props.web.publicURL.split('.').pop() === 'mp4' && <Video src={props.web.publicURL}></Video>}
                 </Browser>}
                 {(props.cover && !props.cover2) && <Browser address><GatsbyImage image={getImage(props.cover.childImageSharp)} alt={props.title} /></Browser>}
             </div>
             </main>
             
     
         </ProjectWrapper>
     );
 }

export default Project